import { render, staticRenderFns } from "./solidityContractDetector.vue?vue&type=template&id=bb383c54&scoped=true&"
import script from "./solidityContractDetector.vue?vue&type=script&lang=js&"
export * from "./solidityContractDetector.vue?vue&type=script&lang=js&"
import style0 from "./solidityContractDetector.vue?vue&type=style&index=0&id=bb383c54&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb383c54",
  null
  
)

export default component.exports